module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-bar#1-1a99d1465f7bbd96efa89f46ec34c67a.svg";